var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { BookingService } from '@ibe/services';
import { ModalService, BrowserService } from '@ibe/services/ui';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
//import { MultipleModalService } from '@ibe.components/common/modal/multiple-modal/multiple-modal.service';
import { TRIP_TYPE_MULTICITY, TRIP_TYPE_ONE_WAY, TRIP_TYPE_ROUND_TRIP } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { ActivatedRoute, Router } from '@angular/router';
var moment = extendMoment(Moment);
var INDRAStopoverConfirmModalComponent = /** @class */ (function (_super) {
    __extends(INDRAStopoverConfirmModalComponent, _super);
    function INDRAStopoverConfirmModalComponent(fb, bookingService, store, modalService, browserService, elementRef, ibeAdminService, ibeAdminConfigService, router, route) {
        var _this = _super.call(this, modalService) || this;
        _this.fb = fb;
        _this.bookingService = bookingService;
        _this.store = store;
        _this.modalService = modalService;
        _this.browserService = browserService;
        _this.elementRef = elementRef;
        _this.ibeAdminService = ibeAdminService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.router = router;
        _this.route = route;
        _this.hasSelectedRoute = true;
        _this.isEligibleRoute = true;
        _this.isLoading = true;
        _this.isAlive = true;
        _this.labels = { departure: 'Departure', arrival: 'Arrival' };
        _this.stopovers$ = _this.store.select(fromStore.getMiniIBEStopovers);
        _this.stopovers = new BehaviorSubject([]);
        _this.availableStopover = {
            portugal: false,
            brasil: false
        };
        _this.selectedStopover = {
            portugal: false,
            brasil: false
        };
        _this.searchRoutes$ = _this.store.select(fromStore.getMiniIBESearchRoutes);
        _this.searchRoutes = [];
        _this.routeType$ = _this.store.select(fromStore.getMiniIBERouteType);
        _this.hasChanges$ = combineLatest(_this.searchRoutes$, _this.stopovers$, _this.routeType$);
        _this.dateRange$ = _this.store.select(fromStore.getMiniIBERangeDates);
        _this.dateOne$ = _this.store.select(fromStore.getMiniIBEDateOne);
        _this.disableSince = '';
        _this.disableUntil = '';
        _this.markDates = '';
        _this.triedToSubmit = false;
        _this.showAnimation = false;
        _this.stopoverSearchRoute = [];
        _this.oneWay = TRIP_TYPE_ONE_WAY;
        _this.nights = [
            {
                label: 1,
                value: 1
            },
            {
                label: 2,
                value: 2
            },
            {
                label: 3,
                value: 3
            },
            {
                label: 4,
                value: 4
            },
            {
                label: 5,
                value: 5
            }
        ];
        _this.setIncrementToDisable = '';
        _this.stopoverDaysMin = 1;
        _this.enable10DaysStopover = _this.ibeAdminConfigService.getConfigurationValue('bookingSearch.enable10DaysStopover') === 'true' ? true : false;
        _this.form = _this.fb.group({
            searchroute: _this.fb.array([]),
            stopover: _this.fb.array([])
        });
        moment.locale(environment.locale);
        _this.form.valueChanges.subscribe(function (value) {
            _this.triedToSubmit = false;
        });
        _this.lottieConfigPortugal = {
            path: './assets/animations/stopover-portugal.json',
            renderer: 'svg',
            autoplay: true,
            loop: true
        };
        _this.lottieConfigBrasil = {
            path: './assets/animations/stopover-brasil.json',
            renderer: 'svg',
            autoplay: true,
            loop: true
        };
        _this.lottieConfigBackground = {
            path: './assets/animations/stopover-background.json',
            renderer: 'svg',
            autoplay: true,
            loop: true
        };
        return _this;
    }
    INDRAStopoverConfirmModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showAnimation = !this.browserService.isDeprecatedBrowser();
        if (this.data) {
            this.airportList = this.data[0].airportList;
        }
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var searchRoutes = _a[0], stopovers = _a[1], routeType = _a[2];
            if (searchRoutes) {
                if (searchRoutes[0].departure && searchRoutes[0].arrival) {
                    var newSearchRoutes = Object.assign([], searchRoutes).splice(0, 1);
                    newSearchRoutes = newSearchRoutes.filter(function (cur) { return cur.arrival && cur.departure; });
                    _this.searchRoutes = newSearchRoutes;
                    _this.labels.departure = newSearchRoutes[0].departure.code + " - " + newSearchRoutes[0].arrival.code;
                    _this.labels.arrival = newSearchRoutes[0].arrival.code + " - " + newSearchRoutes[0].departure.code;
                    var countries = newSearchRoutes.map(function (cur) { return ({ departure: cur.departure.code, arrival: cur.arrival.code }); });
                    if (!countries.length) {
                        _this.hasSelectedRoute = false;
                        _this.isEligibleRoute = true;
                        _this.isLoading = false;
                    }
                    else {
                        _this.isEligibleRoute = true;
                        _this.isLoading = false;
                        _this.route_type = routeType;
                        _this.stopoverSearchRoute =
                            (_this.route_type == TRIP_TYPE_MULTICITY) ? searchRoutes : _this.searchRoutes;
                        var stopoverResponse = _this.data[0].stopoverResponse;
                        if (stopoverResponse && stopoverResponse.length > 0) {
                            _this.INDRA_getStopovers(stopoverResponse);
                        }
                    }
                }
                else {
                    _this.isLoading = false;
                    _this.hasSelectedRoute = false;
                }
            }
        });
        this.dateOne$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value && _this.route_type === TRIP_TYPE_ONE_WAY) {
                var departure = moment(value, 'DD/MM/YYYY');
                _this.form.get('searchroute').patchValue([{ departure: departure }]);
            }
        });
        this.dateRange$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value && value.length > 1 && _this.route_type === TRIP_TYPE_ROUND_TRIP) {
                var departure = moment(value[0], 'DD/MM/YYYY');
                var arrival = moment(value[1], 'DD/MM/YYYY');
                _this.form.get('searchroute').patchValue([{ departure: departure, arrival: arrival }]);
            }
        });
        this.disableUntil = { year: moment().format('YYYY'), month: moment().format('M'), day: moment().subtract(1, 'days').format('D') };
        // this.disableSince = { year: moment().year(), month: moment().month(), day: moment().day() };
        this.form.valueChanges.subscribe(function (value) {
            _this.triedToSubmit = false;
        });
        if (this.enable10DaysStopover) {
            this.nights.push({
                label: 6,
                value: 6
            }, {
                label: 7,
                value: 7
            }, {
                label: 8,
                value: 8
            }, {
                label: 9,
                value: 9
            }, {
                label: 10,
                value: 10
            });
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        if (this.animationPortugal) {
            this.animationPortugal.destroy();
        }
        if (this.animationBrasil) {
            this.animationBrasil.destroy();
        }
        if (this.animationBackground) {
            this.animationBackground.destroy();
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_departureDatepickerOptions = function (dateArrivalFormObj) {
        var until = moment().subtract(1, 'days');
        var disableUntil = {
            year: until.format('YYYY'),
            month: until.format('M'),
            day: until.format('D')
        };
        var since = moment().add(360, 'days');
        var disableSince = {
            year: since.format('YYYY'),
            month: since.format('M'),
            day: since.format('D')
        };
        if (dateArrivalFormObj) {
            var arrival = moment(dateArrivalFormObj.value, 'DD/MM/YYYY');
            disableSince = {
                year: arrival.format('YYYY'),
                month: arrival.format('M'),
                day: arrival.format('D')
            };
        }
        var result = { disableUntil: disableUntil, disableSince: disableSince };
        return result;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_arrivalDatepickerOptions = function (dateDeparture) {
        var since = moment().add(360, 'days');
        var disableSince = {
            year: since.format('YYYY'),
            month: since.format('M'),
            day: since.format('D')
        };
        var result = { disableSince: disableSince };
        if (dateDeparture) {
            var departure = moment(dateDeparture, 'DD/MM/YYYY');
            var disableUntil = {
                year: departure.format('YYYY'),
                month: departure.format('M'),
                day: departure.format('D')
            };
            result['disableUntil'] = disableUntil;
        }
        return result;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_showError = function (control) {
        return this.triedToSubmit && !control.valid;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_stopoverDisable = function () {
        return this.form.get('stopover').value.map(function (cur) { return ({ value: cur.when }); });
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getLabel = function (item, type, idx) {
        if (type === void 0) { type = 'departure'; }
        if (idx === void 0) { idx = 0; }
        var label, infoSearchRoute;
        if (this.route_type == TRIP_TYPE_MULTICITY) {
            infoSearchRoute = this.searchRoutes[idx];
        }
        else {
            infoSearchRoute = this.searchRoutes.find(function (v) { return v.arrival.code == item.arrival.code && v.departure.code == item.departure.code; });
            if (!infoSearchRoute)
                infoSearchRoute = item;
        }
        if (type == 'departure')
            label = infoSearchRoute.departure.location.city + " - " + infoSearchRoute.arrival.location.city;
        if (type == 'arrival')
            label = infoSearchRoute.arrival.location.city + " - " + infoSearchRoute.departure.location.city;
        return label;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getPlaceholder = function (item, type, idx) {
        if (type === void 0) { type = 'departure'; }
        if (idx === void 0) { idx = 0; }
        var label, infoSearchRoute;
        if (this.route_type == TRIP_TYPE_MULTICITY) {
            infoSearchRoute = this.searchRoutes[idx];
        }
        else {
            infoSearchRoute = this.searchRoutes.find(function (v) { return v.arrival.code == item.arrival.code && v.departure.code == item.departure.code; });
            if (!infoSearchRoute)
                infoSearchRoute = item;
        }
        if (type == 'departure')
            label = this.INDRA_getTranslationKey('modals.label.from') + (" " + infoSearchRoute.departure.location.city + " - " + infoSearchRoute.arrival.location.city + "?");
        if (type == 'arrival')
            label = this.INDRA_getTranslationKey('modals.label.from') + (" " + infoSearchRoute.arrival.location.city + " - " + infoSearchRoute.departure.location.city + "?");
        return label;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getCityLabel = function (type) {
        if (type === void 0) { type = 'departure'; }
        var label;
        if (type == 'departure')
            label = this.searchRoutes[0].departure.location.city;
        if (type == 'arrival')
            label = this.searchRoutes[0].arrival.location.city;
        return label;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getCountryLabel = function () {
        if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
            return this.INDRA_getTranslationKey('modals.text.countryLabel');
        }
        else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
            if (this.availableStopover.portugal && this.availableStopover.brasil) {
                return this.INDRA_getTranslationKey('modals.text.portugalBrazil');
            }
            else if (this.availableStopover.portugal) {
                return this.INDRA_getTranslationKey('modals.text.portugal');
            }
            else if (this.availableStopover.brasil) {
                return this.INDRA_getTranslationKey('modals.text.brazil');
            }
        }
        else {
            if (this.selectedStopover.portugal && this.selectedStopover.brasil) {
                return this.INDRA_getTranslationKey('modals.text.countryLabel');
            }
            else if (this.selectedStopover.portugal) {
                return this.INDRA_getTranslationKey('modals.text.portugal');
            }
            else if (this.selectedStopover.brasil) {
                return this.INDRA_getTranslationKey('modals.text.brazil');
            }
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_close = function () {
        this.store.dispatch(new MiniIBEActions.PutIsStopover(false));
        this.closeModal();
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_changeInput = function (event, form) {
        form.setValue(event);
    };
    INDRAStopoverConfirmModalComponent.prototype.compareFn = function (c1, c2) {
        return c1 && c2 ? c1.id === c2.id : c1 === c2;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_handleCancel = function () {
        if (this.router.url.includes('/booking/flights')) {
            this.INDRA_handleCancelForFlightsPage();
        }
        else {
            if (this.data && this.data[0] && this.data[0].handleCancel)
                this.data[0].handleCancel();
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_handleCancelForFlightsPage = function () {
        this.store.dispatch(new MiniIBEActions.PutIsStopover(false));
        this.closeModal();
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_handleClose = function () {
        var _this = this;
        this.triedToSubmit = true;
        if (this.form.valid) {
            // if one country is unchecked clear its values
            var activeStops = this.form.get('stopover').value.filter(function (cur) { return cur.active; });
            if (activeStops.length < 2 && this.form.get('stopover').length > 1) {
                var index = this.form.get('stopover').value.findIndex(function (el) { return el.active == false; });
                this.form.get('stopover').at(index).get('when').setValue('');
                this.form.get('stopover').at(index).get('city').setValue('');
                this.form.get('stopover').at(index).get('days').setValue('');
            }
            this.isLoading = true;
            var formValues_1 = this.form.value;
            var stopover = formValues_1.stopover.filter(function (cur) { return cur.active; });
            for (var i in stopover) {
                var selectedStopoverDetails = this.INDRA_getAirportByCode(stopover[i].city.code);
                stopover[i].city = selectedStopoverDetails;
            }
            // searchRoutes needs only first index for RT/OW single flight row
            // stopoverSearchRoute needs two index for multicity flight rows
            var newSearchRoutes = this.searchRoutes.map(function (cur, idx) {
                var c = { departure: Object.assign({}, cur.departure), arrival: Object.assign({}, cur.arrival), date: cur.date, id: cur.id };
                if (_this.route_type !== TRIP_TYPE_MULTICITY) {
                    c.departure.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                    c.arrival.date = moment(formValues_1.searchroute[idx].arrival, 'DD/MM/YYYY').toDate();
                }
                return c;
            });
            var multicitySearchRoutes = this.stopoverSearchRoute.map(function (cur, idx) {
                var c = { departure: Object.assign({}, cur.departure), arrival: Object.assign({}, cur.arrival), date: cur.date, id: cur.id };
                c.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                c.departure.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                return c;
            });
            this.isAlive = false;
            this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
            if (this.route_type === TRIP_TYPE_MULTICITY) {
                this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicitySearchRoutes));
            }
            else {
                this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
            }
            this.store.dispatch(new MiniIBEActions.PutStovers(stopover));
            this.INDRA_close();
            if (this.data && this.data[0] && this.data[0].handleConfirm)
                this.data[0].handleConfirm();
        }
        else {
            var invalidControl = this.elementRef.nativeElement.querySelector('.form-field .ng-invalid');
            if (invalidControl) {
                invalidControl.scrollIntoView();
                invalidControl.focus();
            }
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_showConfirmButton = function () {
        return true; // TODO
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_handleCountry = function (stopover) {
        this.changeAnimation(this.form.get('stopover'));
        if (stopover.value.active) {
            this.INDRA_setRequiredValidators(stopover);
            this.INDRA_clearValidators(stopover);
            if (this.route_type === TRIP_TYPE_ONE_WAY) {
                // one stop over only in OW
                for (var _i = 0, _a = this.form.get('stopover').controls; _i < _a.length; _i++) {
                    var stopoverArr = _a[_i];
                    stopoverArr.get('active').setValue(false);
                    this.INDRA_clearValidators(stopoverArr);
                }
                stopover.get('when').setValue('outbound');
            }
            stopover.get('active').setValue(true);
            this.INDRA_setRequiredValidators(stopover);
        }
        else {
            this.INDRA_clearValidators(stopover);
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.changeAnimation = function (stops) {
        var _this = this;
        var _loop_1 = function (stop_1) {
            stop_1.get('active').valueChanges.pipe(takeWhile(function () { return _this.isAlive; }))
                .subscribe(function (data) {
                if (stop_1.get('active').value == true) {
                    if (stop_1.get('country').value == 'Brazil') {
                        _this.selectedStopover.brasil = stop_1.get('active').value;
                    }
                    else {
                        _this.selectedStopover.portugal = stop_1.get('active').value;
                    }
                }
                else {
                    if (stop_1.get('country').value == 'Brazil') {
                        _this.selectedStopover.brasil = stop_1.get('active').value;
                    }
                    else {
                        _this.selectedStopover.portugal = stop_1.get('active').value;
                    }
                }
            });
        };
        for (var _i = 0, _a = stops.controls; _i < _a.length; _i++) {
            var stop_1 = _a[_i];
            _loop_1(stop_1);
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_setRequiredValidators = function (form) {
        for (var key in form.controls) {
            form.get(key).setValidators(Validators.required);
            form.get(key).updateValueAndValidity();
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_clearValidators = function (form) {
        for (var key in form.controls) {
            form.get(key).clearValidators();
            form.get(key).updateValueAndValidity();
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getStopovers = function (param) {
        var _this = this;
        // NOTE: this country list should be with complete with its cities regardless of which api response the city was originally from
        var uniqueStopovers = this.createUniqueStopoverList(param);
        if (this.route_type == TRIP_TYPE_ONE_WAY) {
            this.stopovers.next(uniqueStopovers.map(function (cur) {
                cur.options_city = cur.airports.map(function (airports) { return ({
                    label: airports.airportTranslated,
                    value: airports.codAirport
                }); });
                cur.city = cur.airports.map(function (airports) { return ({
                    id: airports.codAirport,
                    code: airports.codAirport
                }); });
                cur.id = _this.stopoverSearchRoute[0].arrival.location.cityName + "-" + _this.stopoverSearchRoute[0].departure.location.cityName;
                cur.when = [
                    {
                        'label': _this.stopoverSearchRoute[0].departure.location.city + " - " + _this.stopoverSearchRoute[0].arrival.location.city,
                        'value': 'outbound'
                    }
                ];
                return cur;
            }));
        }
        else if (this.route_type == TRIP_TYPE_ROUND_TRIP) {
            this.stopovers.next(uniqueStopovers.map(function (cur) {
                cur.options_city = cur.airports.map(function (airports) { return ({
                    label: airports.airportTranslated,
                    value: airports.codAirport
                }); });
                cur.city = cur.airports.map(function (airports) { return ({
                    id: airports.codAirport,
                    code: airports.codAirport
                }); });
                cur.id = _this.stopoverSearchRoute[0].arrival.location.cityName + "-" + _this.stopoverSearchRoute[0].departure.location.cityName;
                cur.when = [
                    {
                        'label': _this.stopoverSearchRoute[0].departure.location.city + " - " + _this.stopoverSearchRoute[0].arrival.location.city,
                        'value': 'outbound'
                    },
                    {
                        'label': _this.stopoverSearchRoute[0].arrival.location.city + " - " + _this.stopoverSearchRoute[0].departure.location.city,
                        'value': 'inbound'
                    }
                ];
                return cur;
            }));
        }
        else {
            // Multicity scenario
            // construct initial stopovers array
            var stopovers_1 = uniqueStopovers.map(function (cur) {
                cur.options_city = cur.airports.map(function (airports) { return ({
                    label: airports.airportTranslated,
                    value: airports.codAirport
                }); });
                cur.city = cur.airports.map(function (airports) { return ({
                    id: airports.codAirport,
                    code: airports.codAirport
                }); });
                cur.id = cur.country;
                return cur;
            });
            // loop into multicity search routes
            this.stopoverSearchRoute.forEach(function (searchRoute, idx) {
                var searchRouteName = searchRoute.departure.code + "-" + searchRoute.arrival.code;
                /*
                 *	check from API response if country was included for the current search route.
                 *	if yes, add search route to the 'when' array of the current stopover country
                 */
                var stopoversPerRoute = param[idx][searchRouteName];
                if (stopoversPerRoute) {
                    stopoversPerRoute.forEach(function (stopoverPerRoute) {
                        var stopoverWithMatchedCountry = stopovers_1.find(function (stopover) { return stopover.country === stopoverPerRoute.country; });
                        if (stopoverWithMatchedCountry) {
                            var whenLabel = searchRoute.departure.location.city + " - " + searchRoute.arrival.location.city;
                            var whenValue = searchRoute.departure.code + "-" + searchRoute.arrival.code;
                            if (stopoverWithMatchedCountry['when'] &&
                                stopoverWithMatchedCountry['when'].length > 0) {
                                stopoverWithMatchedCountry['when'].push({
                                    'label': whenLabel,
                                    'value': 'outbound' + ' ' + whenValue
                                });
                            }
                            else {
                                stopoverWithMatchedCountry['when'] = [
                                    {
                                        'label': whenLabel,
                                        'value': 'outbound' + ' ' + whenValue
                                    }
                                ];
                            }
                        }
                    });
                }
            });
            this.stopovers.next(stopovers_1);
        }
        this.createForm(uniqueStopovers, this.stopoverSearchRoute, false, this.route_type);
        this.availableStopover.portugal = uniqueStopovers.filter(function (stopover) { return stopover.country === 'Portugal'; }).length > 0;
        this.availableStopover.brasil = uniqueStopovers.filter(function (stopover) { return stopover.country === 'Brazil'; }).length > 0;
    };
    /**
     * Create a list of unique stopovers based on the API response for all of the routes
     */
    INDRAStopoverConfirmModalComponent.prototype.createUniqueStopoverList = function (param) {
        var uniqueStopoverRoutes = [];
        this.stopoverSearchRoute.forEach(function (searchRoute, idx) {
            if (searchRoute.departure && searchRoute.arrival) {
                var searchRouteName = searchRoute.departure.code + "-" + searchRoute.arrival.code;
                var stopoversPerRoute = param[idx][searchRouteName];
                if (stopoversPerRoute) {
                    stopoversPerRoute.forEach(function (stopover) {
                        // check if the current stopover country is already on the existing list
                        var matchedList = uniqueStopoverRoutes.filter(function (routes) { return routes.country === stopover.country; });
                        if (matchedList.length === 0) {
                            uniqueStopoverRoutes.push(stopover);
                        }
                        else {
                            /*
                             *	if the current stopover country is already on the existing list,
                             *	check if the city is already on the existing list. If no, add it.
                             */
                            stopover.airports.forEach(function (airport) {
                                matchedList.forEach(function (country) {
                                    var matchedListCountryAiport = country.airports.filter(function (countryAirport) {
                                        return country.country === stopover.country &&
                                            countryAirport.codAirport === airport.codAirport;
                                    });
                                    if (matchedListCountryAiport.length === 0) {
                                        uniqueStopoverRoutes.forEach(function (uniqueStopover) {
                                            uniqueStopover.airports.push(airport);
                                        });
                                    }
                                });
                            });
                        }
                    });
                }
            }
        });
        return uniqueStopoverRoutes;
    };
    /**
     * Create form controls with initial values and restrictions
     */
    INDRAStopoverConfirmModalComponent.prototype.createForm = function (stopovers, searchroutesParam, dataFilled, route_type) {
        var _this = this;
        if (dataFilled === void 0) { dataFilled = false; }
        var searchRoutes = searchroutesParam.map(function (stopover) {
            if (route_type == TRIP_TYPE_ONE_WAY) {
                return _this.fb.group({
                    departure: [stopover.departure && stopover.departure.date ? moment(stopover.departure.date).format('DD/MM/YYYY') : null, Validators.required]
                });
            }
            else if (route_type == TRIP_TYPE_MULTICITY) {
                return _this.fb.group({
                    departure: [stopover.date ? moment(stopover.date).format('DD/MM/YYYY') : null, Validators.required]
                });
            }
            else {
                return _this.fb.group({
                    departure: [stopover.departure && stopover.departure.date ? moment(stopover.departure.date).format('DD/MM/YYYY') : null, Validators.required],
                    arrival: [stopover.arrival && stopover.arrival.date ? moment(stopover.arrival.date).format('DD/MM/YYYY') : null, Validators.required],
                });
            }
        });
        this.form = this.fb.group({
            searchroute: this.fb.array(searchRoutes),
            stopover: this.fb.array(
            // stopovers.countries.map(stopover => {
            stopovers.map(function (stopover) {
                return _this.fb.group({
                    active: [_this.enable10DaysStopover ? true : false],
                    country: [stopover.country],
                    city: ['', Validators.required],
                    when: [_this.enable10DaysStopover && _this.route_type === TRIP_TYPE_ONE_WAY ? 'outbound' : ''],
                    days: [_this.enable10DaysStopover && _this.route_type === TRIP_TYPE_MULTICITY ? 1 : ''],
                    id: [stopover.id],
                });
            })),
        });
        if (dataFilled) {
            var _loop_2 = function (stopover) {
                var indexStopover = void 0;
                if (this_1.route_type == TRIP_TYPE_MULTICITY) {
                    indexStopover = this_1.form.get('stopover').value.findIndex(function (el) { return el.id == stopover.id; });
                }
                else {
                    indexStopover = this_1.form.get('stopover').value.findIndex(function (el) { return el.country == stopover.country; });
                }
                this_1.form.get('stopover').at(indexStopover).setValue(stopover);
                this_1.form.get('stopover').at(indexStopover).get('active').setValue(true);
            };
            var this_1 = this;
            for (var _i = 0, dataFilled_1 = dataFilled; _i < dataFilled_1.length; _i++) {
                var stopover = dataFilled_1[_i];
                _loop_2(stopover);
            }
        }
        var OnlyWhen = function (AC) {
            var stops = AC.get('stopover');
            var actives = stops.value.filter(function (cur) { return cur.active; });
            if (stops.length > 1 /*&& this.route_type != TRIP_TYPE_MULTICITY */) {
                var duplicatesWhen = stops.value
                    .filter(function (cur) { return cur.when; })
                    .map(function (cur) { return cur.when; })
                    .sort()
                    .filter(function (cur, idx, arr) { return cur == arr[idx + 1]; });
                if (duplicatesWhen.length && actives.length > 1)
                    stops.setErrors({ DuplicatesWhen: true });
                if (stops.length && !actives.length)
                    stops.setErrors({ notSelected: true });
            }
            else if (stops.length && !actives.length) {
                stops.setErrors({ notSelected: true });
            }
            else {
                stops.setErrors(null);
                stops.clearValidators();
            }
            return null;
        };
        this.form.setValidators(OnlyWhen);
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_disabled = function () {
        return this.route_type == TRIP_TYPE_MULTICITY ? true : false;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_showNumberOfNights = function () {
        var index = 0;
        if (this.route_type == TRIP_TYPE_ROUND_TRIP) {
            var departureDate = moment(this.form.get('searchroute').at(index).get('departure').value, 'DD/MM/YYYY');
            var arrivalDate = moment(this.form.get('searchroute').at(index).get('arrival').value, 'DD/MM/YYYY');
            if (departureDate && arrivalDate) {
                return true;
            }
        }
        else if (this.route_type == TRIP_TYPE_ONE_WAY) {
            var departureDate = moment(this.form.get('searchroute').at(index).get('departure').value, 'DD/MM/YYYY');
            if (departureDate) {
                return true;
            }
        }
        else if (this.route_type == TRIP_TYPE_MULTICITY) {
            return true;
        }
        return false;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getNights = function () {
        var stopoverDaysLimit = this.enable10DaysStopover ? 10 : 5;
        if (this.route_type == TRIP_TYPE_ROUND_TRIP) {
            if (this.form.value.searchroute && this.form.value.searchroute[0] && this.form.value.searchroute[0].departure && this.form.value.searchroute[0].arrival) {
                var departure = this.form.get('searchroute').at(0).get('departure').value;
                var arrival = this.form.get('searchroute').at(0).get('arrival').value;
                var range = moment.range(moment(departure, 'DD/MM/YYYY'), moment(arrival, 'DD/MM/YYYY'));
                var days = range.diff('days');
                if (days < stopoverDaysLimit) {
                    return this.nights.slice(0, days);
                }
            }
        }
        if (this.route_type == TRIP_TYPE_MULTICITY) {
            if (this.form.value.searchroute && this.form.value.searchroute[0] && this.form.value.searchroute[1] &&
                this.form.value.searchroute[0].departure && this.form.value.searchroute[1].departure) {
                var departureOne = this.form.get('searchroute').at(0).get('departure').value;
                var departureTwo = this.form.get('searchroute').at(1).get('departure').value;
                var range = moment.range(moment(departureOne, 'DD/MM/YYYY'), moment(departureTwo, 'DD/MM/YYYY'));
                var days = range.diff('days');
                if (days < stopoverDaysLimit) {
                    return this.nights.slice(0, days);
                }
            }
        }
        return this.nights;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_changeCity = function (event, item, index) {
        // TODO possibility to change the when dropdown list depending on the city selected
        var result = item.city.find(function (cur) { return cur.id == event.target.value; }) || null;
        this.form.get('stopover').at(index).get('city').setValue(result);
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getCity = function (field) {
        if (field === '')
            return '';
        return field['id'];
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_showBrasil = function () {
        if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
            return true;
        }
        else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
            return this.availableStopover.brasil;
        }
        else {
            return this.selectedStopover.brasil;
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_showPortugal = function () {
        if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
            return true;
        }
        else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
            return this.availableStopover.portugal;
        }
        else {
            return this.selectedStopover.portugal;
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getAirportByCode = function (code) {
        var returnValue = null;
        if (this.airportList && this.airportList.length > 0) {
            returnValue = this.airportList.find(function (airport) { return airport.code == code; });
        }
        return returnValue;
    };
    INDRAStopoverConfirmModalComponent.prototype.handleAnimationPortugal = function (animation) {
        this.animationPortugal = animation;
    };
    INDRAStopoverConfirmModalComponent.prototype.handleAnimationBrasil = function (animation) {
        this.animationBrasil = animation;
    };
    INDRAStopoverConfirmModalComponent.prototype.handleAnimationBackground = function (animation) {
        this.animationBackground = animation;
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_getTranslationKey = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_handleIncrement = function (formControlName) {
        var dayCountSelected = this.form.get('stopover').at(0).get(formControlName).value;
        if (dayCountSelected === this.INDRA_getNights().length) {
            this.setIncrementToDisable = 'enable10Days';
        }
    };
    INDRAStopoverConfirmModalComponent.prototype.INDRA_resetSelectedDayCount = function (event) {
        this.form.get('stopover').at(0).get('days').setValue(this.stopoverDaysMin);
    };
    return INDRAStopoverConfirmModalComponent;
}(AbstractModalContentComponent));
export { INDRAStopoverConfirmModalComponent };
